export default __webpack_public_path__ + "static/media/750x600_01.a336a459.webp";